/** Returns iframe src for YouTube / Vimeo page URLs, or null if not recognized. */
export function getVideoEmbedSrc(url: string | null | undefined): string | null {
  if (!url?.trim()) return null
  const trimmed = url.trim()

  const yt =
    trimmed.match(/(?:youtube\.com\/watch\?v=|youtube\.com\/embed\/|youtu\.be\/)([^&\s?#]+)/i) ||
    trimmed.match(/youtube\.com\/shorts\/([^&\s?#]+)/i)
  if (yt?.[1]) {
    return `https://www.youtube.com/embed/${yt[1]}`
  }

  const vimeo = trimmed.match(/vimeo\.com\/(?:video\/)?(\d+)/i)
  if (vimeo?.[1]) {
    return `https://player.vimeo.com/video/${vimeo[1]}`
  }

  if (trimmed.includes('youtube.com/embed') || trimmed.includes('player.vimeo.com')) {
    return trimmed
  }

  return null
}
